import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../../data/site";

export const WeComeToYou = () => (
    <section data-testid="we-come-to-you-section" className="bg-[#0F2E52]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
            <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight text-white mb-3">
                We Come To You
            </h2>
            <div className="max-w-3xl space-y-3 text-base md:text-lg leading-relaxed text-blue-100 mb-5">
                <p>
                    You shouldn't have to disconnect your computer, carry it to a shop and reconnect everything
                    yourself.
                </p>
                <p>
                    We can troubleshoot many computer and technology problems where they actually occur — in your
                    home or workplace.
                </p>
            </div>
            <a
                href={PHONE_TEL}
                data-testid="we-come-to-you-call-link"
                className="inline-flex items-center gap-2 text-white font-semibold underline underline-offset-4 hover:text-orange-300 transition-colors"
            >
                <Phone className="w-4 h-4" />
                Call {PHONE_DISPLAY}
            </a>
        </div>
    </section>
);
